// src/pages/VideosPage.js
// YouTube channel integration — saree showcase & weaving videos
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// ── CONFIGURATION ──────────────────────────────────────────────
// Replace with your actual YouTube Channel ID
// Get it: YouTube Studio → Customization → Basic Info → Channel ID
const YT_CHANNEL_ID = 'UCxxxxxxxxxxxxxxxxxxxxxxxx'; // ← YOUR CHANNEL ID HERE

// Replace with your YouTube Data API v3 key
// Get it: console.cloud.google.com → APIs → YouTube Data API v3 → Credentials
const YT_API_KEY    = 'AIzaSy_YOUR_KEY_HERE';       // ← YOUR API KEY HERE

// ── CURATED VIDEOS (fallback / featured — add your real video IDs) ──
const CURATED_VIDEOS = [
  {
    id:          'dQw4w9WgXcQ',          // ← Replace with real YouTube video ID
    title:       'Pure Kanjivaram Silk — Weaving Process',
    description: 'Watch our master weavers create a stunning Kanjivaram silk saree with 24K gold zari. An ancient craft preserved for generations.',
    category:    'Weaving',
    duration:    '8:42',
    views:       '12K',
    date:        '2024-03-15',
    tags:        ['Kanjivaram','Silk','Weaving','Zari'],
  },
  {
    id:          'dQw4w9WgXcQ',
    title:       'Bridal Saree Collection 2024 — Full Showcase',
    description: 'Explore our stunning bridal saree collection featuring pure silk, zari work, and traditional Venkatagiri designs.',
    category:    'Collection',
    duration:    '12:18',
    views:       '28K',
    date:        '2024-02-20',
    tags:        ['Bridal','Wedding','Silk'],
  },
  {
    id:          'dQw4w9WgXcQ',
    title:       'Pochampally Ikat — The Art of Resist Dyeing',
    description: 'A deep dive into the traditional Pochampally ikat weaving technique — how geometric patterns are created before weaving.',
    category:    'Documentary',
    duration:    '15:30',
    views:       '8.5K',
    date:        '2024-01-10',
    tags:        ['Ikat','Pochampally','Documentary'],
  },
  {
    id:          'dQw4w9WgXcQ',
    title:       'How to Drape a Venkatagiri Cotton Saree',
    description: 'Step-by-step guide to draping our lightweight Venkatagiri cotton sarees in the traditional Andhra style.',
    category:    'Tutorial',
    duration:    '6:15',
    views:       '45K',
    date:        '2023-12-05',
    tags:        ['Tutorial','Cotton','Draping'],
  },
  {
    id:          'dQw4w9WgXcQ',
    title:       'Festival Collection — Diwali Silk Sarees 2024',
    description: 'Our exclusive Diwali collection featuring vibrant silk sarees with traditional motifs perfect for the festive season.',
    category:    'Collection',
    duration:    '9:50',
    views:       '19K',
    date:        '2023-10-20',
    tags:        ['Festival','Diwali','Silk'],
  },
  {
    id:          'dQw4w9WgXcQ',
    title:       'Behind the Loom — Meet Our Master Weavers',
    description: 'An intimate portrait of the artisan families who have been weaving Venkatagiri sarees for over five generations.',
    category:    'Documentary',
    duration:    '18:22',
    views:       '6.2K',
    date:        '2023-09-15',
    tags:        ['Artisans','Heritage','Documentary'],
  },
  {
    id:          'dQw4w9WgXcQ',
    title:       'Zari Work Explained — Gold Thread Weaving',
    description: 'Understanding the difference between real zari, tested zari, and synthetic — how to identify authentic handloom zari work.',
    category:    'Education',
    duration:    '11:05',
    views:       '22K',
    date:        '2023-08-01',
    tags:        ['Zari','Education','Authentication'],
  },
  {
    id:          'dQw4w9WgXcQ',
    title:       'Saree Care Guide — Silk & Cotton Maintenance',
    description: 'How to wash, store, and maintain your precious handloom sarees to keep them looking new for decades.',
    category:    'Tutorial',
    duration:    '7:33',
    views:       '31K',
    date:        '2023-07-10',
    tags:        ['Care','Tutorial','Maintenance'],
  },
];

const CATEGORIES = ['All', 'Collection', 'Weaving', 'Tutorial', 'Documentary', 'Education'];

const YT_THUMB = (id, quality='hqdefault') =>
  `https://img.youtube.com/vi/${id}/${quality}.jpg`;

export default function VideosPage() {
  const [videos,      setVideos]      = useState(CURATED_VIDEOS);
  const [activeVideo, setActiveVideo] = useState(null);
  const [category,    setCategory]    = useState('All');
  const [loading,     setLoading]     = useState(false);
  const [ytLoaded,    setYtLoaded]    = useState(false);

  // Try to load from YouTube API (if key is configured)
  useEffect(() => {
    if (YT_API_KEY.includes('YOUR_KEY') || YT_CHANNEL_ID.includes('xxx')) {
      // No real API key — use curated list
      return;
    }
    setLoading(true);
    fetch(`https://www.googleapis.com/youtube/v3/search?key=${YT_API_KEY}&channelId=${YT_CHANNEL_ID}&part=snippet&order=date&maxResults=24&type=video`)
      .then(r => r.json())
      .then(data => {
        if (data.items?.length) {
          const mapped = data.items.map(item => ({
            id:          item.id.videoId,
            title:       item.snippet.title,
            description: item.snippet.description,
            category:    'YouTube',
            duration:    '',
            views:       '',
            date:        item.snippet.publishedAt?.split('T')[0],
            tags:        [],
          }));
          setVideos(mapped);
          setYtLoaded(true);
        }
      })
      .catch(() => {}) // fall back to curated
      .finally(() => setLoading(false));
  }, []);

  const filtered = category === 'All' ? videos : videos.filter(v => v.category === category);
  const featured = filtered[0];
  const rest     = filtered.slice(1);

  return (
    <div className="page">
      {/* ── PAGE HEADER ── */}
      <div style={{position:'relative',background:'#1a0f0f',overflow:'hidden',minHeight:220,display:'flex',alignItems:'center',justifyContent:'center'}}>
        {/* Chenetha pattern overlay */}
        <div style={{position:'absolute',inset:0,opacity:0.12,backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill='none' stroke='%23c9a84c' stroke-width='0.5'%3E%3Cpolygon points='20,4 36,20 20,36 4,20'/%3E%3Ccircle cx='20' cy='20' r='3' fill='%23c9a84c'/%3E%3C/g%3E%3C/svg%3E")`,backgroundSize:'40px 40px'}}/>
        <div style={{position:'absolute',inset:0,background:'linear-gradient(180deg,rgba(122,31,31,0.25) 0%,rgba(10,2,2,0.85) 100%)'}}/>
        <div style={{position:'relative',zIndex:2,textAlign:'center',padding:'48px 24px'}}>
          <div style={{fontSize:10,letterSpacing:4,color:'#c9a84c',marginBottom:10,textTransform:'uppercase',fontFamily:"'Jost',sans-serif"}}>✦ Handloom Stories ✦</div>
          <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(2rem,5vw,3.5rem)',color:'#fff',fontStyle:'italic',marginBottom:12}}>Our <em style={{color:'#e8c96a'}}>Stories</em> & Crafts</h1>
          <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(14px,2vw,18px)',color:'rgba(255,255,255,0.7)',maxWidth:560,margin:'0 auto 20px',fontStyle:'italic'}}>Watch the magic of handloom weaving, saree showcases, and artisan stories from our looms in Venkatagiri.</p>
          <a href={`https://www.youtube.com/@VenkatagitiHandlooms`} target="_blank" rel="noopener noreferrer"
            style={{display:'inline-flex',alignItems:'center',gap:10,background:'#FF0000',color:'#fff',padding:'11px 24px',textDecoration:'none',fontFamily:"'Jost',sans-serif",fontSize:12,fontWeight:600,letterSpacing:1,textTransform:'uppercase'}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            Subscribe on YouTube
          </a>
        </div>
        <div style={{position:'absolute',bottom:0,left:0,right:0,height:3,background:'linear-gradient(90deg,transparent,#c9a84c,transparent)'}}/>
      </div>

      <div className="container" style={{padding:'48px 24px 72px'}}>

        {/* ── CATEGORY FILTER ── */}
        <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:36,justifyContent:'center'}}>
          {CATEGORIES.map(cat => (
            <button key={cat} onClick={()=>setCategory(cat)}
              style={{padding:'8px 20px',border:'1.5px solid',fontFamily:"'Jost',sans-serif",fontSize:11,letterSpacing:1.5,textTransform:'uppercase',cursor:'pointer',transition:'all 0.2s',
                borderColor:category===cat?'#7a1f1f':'#e8ddd0',background:category===cat?'#7a1f1f':'transparent',color:category===cat?'#fff':'#5a3a3a'}}>
              {cat}
            </button>
          ))}
        </div>

        {loading ? <div className="spinner"/> : (
          <>
            {/* ── FEATURED VIDEO ── */}
            {featured && (
              <div style={{marginBottom:48}}>
                <div style={{fontSize:10,letterSpacing:3,color:'#c9a84c',marginBottom:8,textTransform:'uppercase',fontFamily:"'Jost',sans-serif"}}>Featured Video</div>
                <div style={{display:'grid',gridTemplateColumns:'3fr 2fr',gap:32,alignItems:'start'}}>
                  <div>
                    <div className="video-thumb" style={{borderRadius:0}} onClick={()=>setActiveVideo(featured)}>
                      <img src={YT_THUMB(featured.id,'maxresdefault')}
                        onError={e=>{e.target.src=YT_THUMB(featured.id,'hqdefault');}}
                        alt={featured.title}/>
                      <div className="play-btn"><div className="play-icon">▶</div></div>
                      {featured.duration && <span className="video-duration">{featured.duration}</span>}
                    </div>
                  </div>
                  <div style={{paddingTop:8}}>
                    <span style={{display:'inline-block',background:'#7a1f1f',color:'#fff',fontSize:9,letterSpacing:2,textTransform:'uppercase',padding:'3px 10px',marginBottom:12,fontFamily:"'Jost',sans-serif"}}>{featured.category}</span>
                    <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.3rem,2.5vw,2rem)',color:'#1a0f0f',lineHeight:1.3,marginBottom:12,fontStyle:'italic'}}>{featured.title}</h2>
                    <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:17,color:'#5a3a3a',lineHeight:1.8,marginBottom:16}}>{featured.description}</p>
                    <div style={{display:'flex',gap:16,fontSize:12,color:'#8a7968',fontFamily:"'Jost',sans-serif",marginBottom:20}}>
                      {featured.views && <span>👁 {featured.views} views</span>}
                      {featured.date  && <span>📅 {new Date(featured.date).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})}</span>}
                    </div>
                    {featured.tags.length>0 && (
                      <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:20}}>
                        {featured.tags.map(t=><span key={t} style={{fontSize:11,background:'#f0e8e0',color:'#7a1f1f',padding:'3px 10px',fontFamily:"'Jost',sans-serif"}}>#{t}</span>)}
                      </div>
                    )}
                    <button onClick={()=>setActiveVideo(featured)} className="btn btn-primary" style={{fontSize:11}}>
                      ▶ Watch Now
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ── VIDEO GRID ── */}
            {rest.length > 0 && (
              <>
                <div style={{borderBottom:'1px solid var(--border)',paddingBottom:16,marginBottom:28}}>
                  <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.4rem,2.5vw,2rem)',color:'#7a1f1f',fontStyle:'italic'}}>
                    {category === 'All' ? 'All Videos' : category}
                  </h2>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:24}}>
                  {rest.map(video => (
                    <div key={video.id} style={{cursor:'pointer'}} onClick={()=>setActiveVideo(video)}>
                      <div className="video-thumb">
                        <img src={YT_THUMB(video.id,'mqdefault')}
                          onError={e=>{e.target.src=YT_THUMB(video.id,'default');}}
                          alt={video.title}/>
                        <div className="play-btn"><div className="play-icon" style={{width:48,height:48,fontSize:18}}>▶</div></div>
                        {video.duration && <span className="video-duration">{video.duration}</span>}
                      </div>
                      <div style={{padding:'12px 0'}}>
                        <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:6}}>
                          <span style={{fontSize:9,background:'#f0e8e0',color:'#7a1f1f',padding:'2px 8px',fontFamily:"'Jost',sans-serif",letterSpacing:1,textTransform:'uppercase'}}>{video.category}</span>
                          {video.views && <span style={{fontSize:11,color:'#8a7968',fontFamily:"'Jost',sans-serif"}}>👁 {video.views}</span>}
                        </div>
                        <h3 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,color:'#1a0f0f',lineHeight:1.3,marginBottom:4}}>{video.title}</h3>
                        {video.date && <div style={{fontSize:11,color:'#aaa',fontFamily:"'Jost',sans-serif"}}>{new Date(video.date).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* ── YOUTUBE CHANNEL CTA ── */}
            <div style={{marginTop:56,background:'linear-gradient(135deg,#1a0f0f,#2d1f1f)',padding:'48px 32px',textAlign:'center',position:'relative',overflow:'hidden'}}>
              <div style={{position:'absolute',inset:0,opacity:0.08,backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cg fill='none' stroke='%23c9a84c' stroke-width='0.4'%3E%3Cpolygon points='16,3 29,16 16,29 3,16'/%3E%3C/g%3E%3C/svg%3E")`,backgroundSize:'32px 32px'}}/>
              <div style={{position:'relative',zIndex:2}}>
                <div style={{fontSize:48,marginBottom:16}}>📺</div>
                <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.5rem,3vw,2.2rem)',color:'#fff',fontStyle:'italic',marginBottom:10}}>More Stories on YouTube</h3>
                <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:17,color:'rgba(255,255,255,0.65)',marginBottom:28,maxWidth:480,margin:'0 auto 28px',fontStyle:'italic'}}>Subscribe to our channel for new weaving videos, saree collections, and artisan stories every week.</p>
                <a href="https://www.youtube.com/@VenkatagitiHandlooms" target="_blank" rel="noopener noreferrer"
                  style={{display:'inline-flex',alignItems:'center',gap:12,background:'#FF0000',color:'#fff',padding:'14px 32px',textDecoration:'none',fontFamily:"'Jost',sans-serif",fontSize:13,fontWeight:700,letterSpacing:1.5,textTransform:'uppercase'}}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                  Subscribe Now
                </a>
              </div>
            </div>
          </>
        )}
      </div>

      {/* ── VIDEO MODAL ── */}
      {activeVideo && (
        <div className="modal-overlay" onClick={()=>setActiveVideo(null)}>
          <button className="modal-close" onClick={()=>setActiveVideo(null)}>✕</button>
          <div style={{width:'92vw',maxWidth:960,position:'relative',zIndex:10}} onClick={e=>e.stopPropagation()}>
            <div style={{aspectRatio:'16/9',background:'#000'}}>
              <iframe
                style={{width:'100%',height:'100%',border:'none'}}
                src={`https://www.youtube.com/embed/${activeVideo.id}?autoplay=1&rel=0&modestbranding=1`}
                title={activeVideo.title}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen/>
            </div>
            <div style={{background:'#fff',padding:'16px 20px',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8}}>
              <div>
                <h3 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,color:'#1a0f0f',marginBottom:2}}>{activeVideo.title}</h3>
                <div style={{fontSize:12,color:'#8a7968',fontFamily:"'Jost',sans-serif"}}>{activeVideo.category} {activeVideo.date&&`· ${new Date(activeVideo.date).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})}`}</div>
              </div>
              <a href={`https://youtube.com/watch?v=${activeVideo.id}`} target="_blank" rel="noopener noreferrer"
                style={{display:'inline-flex',alignItems:'center',gap:6,background:'#FF0000',color:'#fff',padding:'8px 16px',textDecoration:'none',fontFamily:"'Jost',sans-serif",fontSize:11,fontWeight:600,letterSpacing:1,whiteSpace:'nowrap'}}>
                ▶ Open on YouTube
              </a>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @media(max-width:768px){
          .videos-featured-grid { grid-template-columns:1fr!important; }
          .videos-grid { grid-template-columns:1fr 1fr!important; }
        }
        @media(max-width:480px){
          .videos-grid { grid-template-columns:1fr!important; }
        }
      `}</style>
    </div>
  );
}
